import { useGetDriverProfilePictureQuery } from '@/pages/Business/pages/Drivers/services';
import type { DriverApi } from '@/pages/Business/pages/Drivers/models';
import { Avatar, Radio } from '@mui/material';

export interface DriverItemProps {
  driver: DriverApi;
  selected: boolean;
  onSelect: (id: string) => void;
}

const DriverItem = ({ driver, selected, onSelect }: DriverItemProps) => {
  const { data: pictureData } = useGetDriverProfilePictureQuery(
    { id: driver.id },
    { skip: !driver.id }
  );

  const initials = `${driver.firstName?.[0] ?? ''}${driver.lastName?.[0] ?? ''}`.toUpperCase();

  return (
    <div
      onClick={() => onSelect(driver.id)}
      className={`flex items-center gap-3 border rounded-lg px-3 py-2 mb-2 cursor-pointer hover:bg-gray-50 ${
        selected ? 'border-orange-400 bg-orange-50' : 'border-gray-200'
      }`}
    >
      <Radio checked={selected} onChange={() => onSelect(driver.id)} size='small' />
      <Avatar
        src={pictureData?.imageUrl ?? undefined}
        sx={{ width: 52, height: 52, fontSize: 18 }}
      >
        {initials}
      </Avatar>
      <div className='flex flex-col'>
        <span className='text-lg font-medium text-gray-800'>
          {driver.firstName} {driver.lastName}
        </span>
        {(driver.workPhoneNumber || driver.personalPhoneNumber) && (
          <span className='text-base text-gray-500'>
            {driver.workPhoneNumber ?? driver.personalPhoneNumber}
          </span>
        )}
      </div>
    </div>
  );
};

export default DriverItem;
